import axios from "axios";
import { getApiUrl } from "../../constants/api";

export const axiosPublic = axios.create({
  baseURL: getApiUrl(),
});

export default axiosPublic;
